import { useEffect, useState } from 'react';

/**
 * Tracks a CSS media query and re-renders on changes (resize, rotation).
 * @param {string} query e.g. '(max-width: 767px)'
 * @returns {boolean} whether the query currently matches
 */
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);

    setMatches(mediaQueryList.matches);
    mediaQueryList.addEventListener('change', handleChange);

    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
